<script lang="ts">
    import {Router, Route} from 'svelte-routing'

    //import Cabinet from "./components/cabinet/Routes.svelte";
    import Main from "./components/main/Routes.svelte";

    export let url = '' // use for SSR only
</script>

<Router {url} basepath="/">
    <Main/>
<!--    <Cabinet/>-->
</Router>
